import { render, staticRenderFns } from "./PaginationSeparated.vue?vue&type=template&id=5bfcbefb"
import script from "./PaginationSeparated.vue?vue&type=script&lang=js"
export * from "./PaginationSeparated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports